import loadable from '@loadable/component';
import { WithLazyHydration } from '../../../WithLazyHydration';

const ExternalLinkDisclaimerLoadable = loadable(
  () => import('./ExternalLinkDisclaimer'),
  {
    resolveComponent: components => components.ExternalLinkDisclaimer
  }
);

export const ExternalLinkDisclaimer = WithLazyHydration(
  ExternalLinkDisclaimerLoadable,
  { name: 'ExternalLinkDisclaimer' }
);
